<template>
  <div class="joinagree">
    <div class="login_bg"></div>
    <div class="login">
      <div class="title_section">
        <div class="title">STEP 1. 약관에 동의 해주세요</div>
        
        <div class="mt-10 title">
          개인정보 수집 및 이용
        </div>

        <div class="table-container">
          <v-data-table dense outlined 
            id="agreeTerms" 
            ref="agreeTerms"
            :headers="agreeHeaders"
            :items="agreeItems"
            fixed-header
            hide-default-footer
          >
          </v-data-table>
        </div>

        <div class="check-info">
          <v-checkbox class="agreeCheck"
            color=#005B96
            v-model="agreeCheck"
            label="동의"
          />
        </div>

        <div class="flex vertical-center">
          <button class="btn_close"
            id="cancel" 
            ref="cancel" 
            @click="cancel()">
            취소
          </button>
          <button class="btn_confirm" 
            id="next" 
            ref="next" 
            type="submit" 
            @click.prevent="next()"
          >
            다음
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "JoinStep2",
  components: {},
  data() {
    return {
      agreeCheck: false,
      agreeItems: [
        {col1: "회원제 서비스 이용 / 본인확인", col2: "이름/아이디/비밀번호/생일/성별/이메일/휴대폰/생년월일", col3: "회원탈퇴 후 6일까지"},
        {col1: "회원제 서비스 이용 / 상품구매", col2: "연락처/휴대폰/주소/IP", col3: "회원탈퇴 후 3개월까지"},
      ],
      agreeHeaders: [
        { text: '목적', align: 'left', sortable: false, value: 'col1', width: "25%" },
        { text: '항목', sortable: false, value: 'col2', width: "45%"},
        { text: '보유기간', sortable: false, value: 'col3', width: "30%" },
      ],
    };
  },
  created() {
    this.$store.commit("resMessage","약관에 동의후 다음으로 이동하세요.");
  },
  methods: {
    cancel() {
      this.$router.push({
        name: "Login",
      });
    },
    next() {
      if (!this.agreeCheck) {
        alert("약관에 동의해 주세요.");
        return;
      }
      this.$router.push({
        name: "JoinInfo",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/base.scss';

.joinagree{
  position: relative; 
  display: flex;
  justify-content: center; 
  align-items: center;
  min-height: 100vh;
  width: 100vw;
  margin-top:-5px;
  margin-left:-87px;
}
.login_bg{
  background-image: url("../../assets/login/background.png");
  background-repeat: no-repeat;
  background-size: cover; 
  width: 100vw; /* 전체 화면 너비 */
  height: 100vh; /* 전체 화면 높이 */
  background-position: center; 
  position: absolute; 
  top: 0; 
  left: 0;
  opacity: 0.2; 
}
.login{
  background-color:white;
  padding:30px;
  border-radius: 40px;
  position: relative;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  text-align: center;
  width:70rem;
  aspect-ratio: 1 / 0.4;

  display: flex;
  flex-direction: column;
}
.title_section {
  margin-left:10px;
  text-align: left;
  letter-spacing: -0.72px;
  // margin-bottom: 4px;
}
.table-container{
  // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  overflow-y: auto;
  border-radius: 20px;
  border: 1px solid #ddd;
  margin-top:10px;
}
.check-info{
  display:flex;
  justify-content:right;
  margin-right:10px;
}
.agreeCheck {
  color:#005B96 !important;
  font-size:12pt !important;
  font-weight: bold !important;
}
.normal-btn{
  color:white !important;
  font-size:12pt !important;
  font-weight: bold !important;
  background-color: $main-color !important;
}
.btn_confirm {
  float: left;
  width: 96px;
  height: 50px;
  margin-top: 26px;
  margin-right: 10px;
  background-color: #005B96;
  border-radius: 30px;
  color: white;
  outline: none;
  border: none;

  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.4px;
  cursor: pointer;
}
.btn_close {
  float: left;
  width: 96px;
  height: 50px;
  margin-top: 26px;
  margin-right: 30px;
  background-color: rgb(221, 221, 221);
  border-radius: 30px;
  color: #005B96;
  outline: none;
  border: none;

  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.4px;
  cursor: pointer;
}
</style>
